import { render, staticRenderFns } from "./VideoAndEditorView.vue?vue&type=template&id=5f799f62&scoped=true&"
import script from "./VideoAndEditorView.vue?vue&type=script&lang=js&"
export * from "./VideoAndEditorView.vue?vue&type=script&lang=js&"
import style0 from "./VideoAndEditorView.vue?vue&type=style&index=0&id=5f799f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f799f62",
  null
  
)

export default component.exports